import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import VatDisplayer from '../../partials/VATDisplayer';
import LoadingSpinner from '../loadingSpinner/loadingSpinner';
import { formatToTwoDecimalPlaces } from '../../constants/constants';
import { useOrganizationSettingsStore } from '../../store/organizationSettingsStore';
import { useDashboardFilterDateStore } from '../../store/dateRangeStore';
import {Tooltip} from "@mui/material";
import infoIcon from '../../assets/icons/info-icon.svg';

interface ReportCardProps {
    title: string;
    value: number;
    color: string;
    icon?: string;
    additionalInfo?: string;
    additionalValue?: string;
    isLoading: boolean;
    currency?: string;
    tooltip?: string;
}

const ReportCard: FC<ReportCardProps> = (props) => {
  const { t } = useTranslation();
  const { dashboardFilterDateRange } = useDashboardFilterDateStore();

  return (
    <div className={`flex h-[150px] w-full  flex-col rounded-[8px] bg-white px-[28px] py-[25px] 
    ${props.icon ? '' : 'flex-col-reverse justify-end'}`}
    >
      <div className="flex items-center justify-between">
        {props.icon && <img src={props.icon} alt={props.title} className="h-[32px] w-[32px]" />}
        <p className={`flex flex-row-reverse gap-2 text-[24px] font-medium text-primary ${!props.icon && 'mt-4'}`}>
          {props.isLoading
            ? <LoadingSpinner color="primary" size={25} />
            : (
              <>
                <VatDisplayer
                  value={props.value}
                />
                {props.currency && (
                <div className="padd pt-1.5 text-xs text-[#6D919E]">
                  {props.currency}
                </div>
                )}
              </>
            )}
        </p>
      </div>
        {props.icon && <p className="text-sm flex items-center gap-4 mt-4 text-primary">{t(props.title)}
            <Tooltip title={props.tooltip}><img className='h-[12px]' src={infoIcon}/></Tooltip>
        </p> }
      <div className={`${props.color} mb-1 border-b`} />
      <div className="flex w-full justify-end">
        {props.additionalInfo && dashboardFilterDateRange[0] == null && (
        <p className="text-sm text-gray-500">
          {t(props.additionalInfo)}
        </p>
        )}
      </div>
        {!props.icon && <p className="text-sm flex items-center gap-4 text-primary">{t(props.title)}
            <Tooltip title={props.tooltip}><img className='h-[12px]' src={infoIcon}/></Tooltip>
        </p> }
    </div>
  );
};

export default ReportCard;
